import { RattachementResumeDTO } from './RattachementResumeDTO';

export interface Entity {
  id?: string;
  name?: string;
  logo?: string;
  adresseGeographique?: string;
  adressePostale?: string;
  telephone?: string;
  email?: string;
  siteInternet?: string;
  identifiantNotaconnect?: string;
  nomAbrege?: string;
  courDappel?: string;
  departementsCouverts?: string[];
  crpcen?: string;
  type?: string;
  typeEntite?: TypeEntityEnum;
  statut?: string;
  residence?: string;
  departementDeResidence?: string;
  siren?: string;
  siret?: string;
  idnRattachement?: string;
  ctmAdrGeoVille?: string;
  ctmAdrGeoCodePostal?: string;
  ctmAdrGeo1?: string;
  ctmAdrGeo2?: string;
  ctmAdrGeo3?: string;
  ctmAdrGeo4?: string;
  ctmAdrGeo5?: string;
  ctmAdrPostaleCodePostal?: string;
  ctmAdrPostaleVille?: string;
  ctmAdrPostale1?: string;
  ctmAdrPostale2?: string;
  ctmAdrPostale3?: string;
  ctmAdrPostale4?: string;
  ctmAdrPostale5?: string;
  ctmDenominationSociale?: string;
  ctmDenominationSocialeAbregee?: string;
  ctmIntitule?: string;
  ctmFormeJuridique?: string;
  ctmLibelle?: string;
  rattachement?: RattachementResumeDTO;
}

export type TypeEntityEnum = 'office' | 'instance' | 'partenaire' | 'organisme' | 'STON' | 'inconnu';
export const TypeEntityEnum = {
  OFFICE: 'office' as TypeEntityEnum,
  INSTANCE: 'instance' as TypeEntityEnum,
  PARTENAIRE: 'partenaire' as TypeEntityEnum,
  ORGANISME: 'organisme' as TypeEntityEnum,
  STON: 'STON' as TypeEntityEnum,
  INCONNU: 'inconnu' as TypeEntityEnum,
};
